const CareerPathwaysFinanceLayout = <template>{{outlet}}</template>;

export default CareerPathwaysFinanceLayout;
